/**
 * @flow
 */

import styled from 'styled-components'
import { lighten, darken } from 'polished'
import { withTenant } from '../../context/tenantConfig'

const Button = styled.button`
  display: inline-block;
  padding: 9px 25px;
  border: 1px solid;
  border-color: ${props => props.tenant.config.theme.primary};
  border-radius: 2px;
  background: transparent;
  color: ${props => props.tenant.config.theme.primary};
  margin-right: 10px;
  margin-top: 10px;
  margin-left: auto;
  outline: none;
  transition: all 0.4s ease;
  user-select: none;

  &:focus:not(:hover) {
    background-color: ${props => darken(0.1, props.tenant.config.theme.primary)};
    border-color: ${props => lighten(0.2, props.tenant.config.theme.primary)};
    color: ${props => lighten(0.8, props.tenant.config.theme.primary)};
  }

  &:hover {
    background: ${props => props.tenant.config.theme.primary};
    color: ${props => props.tenant.config.theme.background};
    cursor: pointer;

    @media screen and (max-width: 850px) {
      background: transparent;
      color: ${props => props.tenant.config.theme.primary};
    }
  }

  i {
    color: ${props => props.tenant.config.theme.primary};
  }

  &:disabled {
    border-color: #444;
    color: #444;

    &:hover {
      background: ${props => props.tenant.config.theme.background};
      border-color: #444;
      color: #444;
      cursor: not-allowed;
    }

    i {
      color: #444;
    }

    &:active {
      position: initial;
    }
  }
`

export default withTenant(Button)
